import {
    GET_ROLE_EVENTS_SUCCESS,
    GET_ROLE_EVENTS_FAILURE
} from "./actions";

const initialState = {
    getRoleEventsResult: {
        success: true
    },
    roleEventsResult: {
        Items: []
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ROLE_EVENTS_SUCCESS:
            return { ...state, getRoleEventsResult: { success: true }, roleEventsResult: action.payload };
        case GET_ROLE_EVENTS_FAILURE:
            return {
                ...state, getRoleEventsResult: { success: false, ...action.payload }, roleEventsResult: {
                    Items: []
                }
            };
        default:
            return state;
    }
};
